import Moment from 'moment';
import {extendMoment} from 'moment-range';

const moment = extendMoment(Moment);

export const formatDate = (date) => {
    return moment(date).format('L');
};
